// import React, { useState, Fragment, Component } from 'react'
// import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import React, { Fragment, useState, Component, useRef, useEffect} from "react"

import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { AvField, AvForm} from "availity-reactstrap-validation"

import apiResponse from '../../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import Tabledetailpresensi from './Components/TableDetailComponent'

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
            setMulai : '',
            setSelesai : ''
        }
    }
    

    componentDidMount() {
        // const activeRef = useRef();


        this.detailBloc.fetchDetail({uuid: this.props.uuid})
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
    }

    reset = () =>
    {
        this.setState({setMulai:'', setSelesai:''})
    }


    render() {

        // const [nip, setMulai] = useState('')
        // const [name, setSelesai] = useState('')

        // function handleButtonReset() {
        //     setMulai('');
        //     setSelesai('');
        // }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="riwayatsumpah"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Kehadiran Tanpa Keterangan</CardTitle>
                                    <CardSubtitle className="mb-1">
                                        Informasi Detail Kehadiran Tanpa Keterangan
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_name !== "" ? this.state.detail.employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Periode Mulai
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="start_period"
                                                    placeholder="Periode Mulai..."
                                                    type="date"
                                                    errorMessage="Masukkan Periode Mulai"
                                                    className="form-control"
                                                    onChange={event => this.setState({setMulai:event.target.value})}
                                                    id="start_period"
                                                    value={this.state.setMulai}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Periode Akhir
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="end_period"
                                                    placeholder="Periode Akhir..."
                                                    type="date"
                                                    errorMessage="Masukkan Periode Akhir"
                                                    className="form-control"
                                                    onChange={event => this.setState({setSelesai:event.target.value})}
                                                    id="end_period"
                                                    value={this.state.setSelesai}
                                                />
                                            </Col>
                                        </Row>
                                        <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            // onClick={() => {
                                            //     handleButtonSearch()
                                            // }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                                this.reset()
                                            }}
                                          >
                                            <i className="uil-refresh"></i> Reset
                                        </Button>
                                    </Col>
                                    <hr></hr>

                                    <Col >
                                      <Tabledetailpresensi uuid={this.props.uuid}></Tabledetailpresensi>
                                    </Col>
                                                                            
                                        <Row className="mb-1">
                                            <Col md="3"></Col>
                                            {/* <Col md="9"> */}
                                                <Link to="/izinpegawai/ketidakhadirantanpaketerangan.html?" className="waves-effect">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            {/* </Col> */}
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);